module.exports = "/assets/data/10c9fa4fc3e383a45ec377cdfae11ccc-MK44.data.json";